/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Backend_Development_Doc_Title3Inputs */

const en_svc_backend_development_doc_title3 = /** @type {(inputs: Svc_Backend_Development_Doc_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Docs & testing`)
};

const ar_svc_backend_development_doc_title3 = /** @type {(inputs: Svc_Backend_Development_Doc_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التوثيق والاختبار`)
};

const bn_svc_backend_development_doc_title3 = /** @type {(inputs: Svc_Backend_Development_Doc_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডকস ও টেস্টিং`)
};

const de_svc_backend_development_doc_title3 = /** @type {(inputs: Svc_Backend_Development_Doc_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumente und Tests`)
};

const es_svc_backend_development_doc_title3 = /** @type {(inputs: Svc_Backend_Development_Doc_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentos y pruebas`)
};

const fr_svc_backend_development_doc_title3 = /** @type {(inputs: Svc_Backend_Development_Doc_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documents et tests`)
};

const pt_svc_backend_development_doc_title3 = /** @type {(inputs: Svc_Backend_Development_Doc_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentos e testes`)
};

const zh_svc_backend_development_doc_title3 = /** @type {(inputs: Svc_Backend_Development_Doc_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文档和测试`)
};

const tr_svc_backend_development_doc_title3 = /** @type {(inputs: Svc_Backend_Development_Doc_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belgeler ve testler`)
};

const ru_svc_backend_development_doc_title3 = /** @type {(inputs: Svc_Backend_Development_Doc_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Документация и тестирование`)
};

const pl_svc_backend_development_doc_title3 = /** @type {(inputs: Svc_Backend_Development_Doc_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumentacja i testy`)
};

/**
* | output |
* | --- |
* | "Docs & testing" |
*
* @param {Svc_Backend_Development_Doc_Title3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_backend_development_doc_title3 = /** @type {((inputs?: Svc_Backend_Development_Doc_Title3Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Backend_Development_Doc_Title3Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_backend_development_doc_title3(inputs)
	if (locale === "bn") return bn_svc_backend_development_doc_title3(inputs)
	if (locale === "de") return de_svc_backend_development_doc_title3(inputs)
	if (locale === "es") return es_svc_backend_development_doc_title3(inputs)
	if (locale === "fr") return fr_svc_backend_development_doc_title3(inputs)
	if (locale === "pt") return pt_svc_backend_development_doc_title3(inputs)
	if (locale === "zh") return zh_svc_backend_development_doc_title3(inputs)
	if (locale === "tr") return tr_svc_backend_development_doc_title3(inputs)
	if (locale === "ru") return ru_svc_backend_development_doc_title3(inputs)
	if (locale === "pl") return pl_svc_backend_development_doc_title3(inputs)
	return en_svc_backend_development_doc_title3(inputs)
});
export { svc_backend_development_doc_title3 as "svc_backend-development_DOC_title" }